<ul class="list-ctx" ng-sortable="$ctrl.sortableConfig">
    <li ng-repeat="item in $ctrl.listItems track by item.index">
        <div class="content-wrapper list-item loaded" ng-class="$ctrl.activeClassNames(item.id, item.index)" ng-click="$ctrl.itemClick($event, item.id, item)">
            <div ng-if="item.indicatorColor" class="indicator" ng-class="item.indicatorColor"></div>
            <div ng-if="$ctrl.listOptions.showCheckboxes" class="checkbox" ng-click="$ctrl.clickPassthru($event, item.id, item)">
                <c-checkbox checked="$ctrl.checkedBox(item.id)"></c-checkbox>
            </div>
            <div class="container">
                <c-list-item-container item-template="$ctrl.itemTemplate" list-item="item" highlight="$ctrl.highlightWords"></c-list-item-container>
            </div>
        </div>
    </li>
</ul>